import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLang } from '../../contexts/LangContext';
import './IdPrototipoScreen.css';

const dias = [
  { sem: 'S', dia: '14' },
  { sem: 'T', dia: '15', ativo: true },
  { sem: 'Q', dia: '16' },
  { sem: 'Q', dia: '17', ponto: true },
  { sem: 'S', dia: '18' },
  { sem: 'S', dia: '19' },
];

const metas = [
  { titulo: 'Movimento', subtitulo: '3 vezes na semana', valor: '1/3', tom: 'terra', icone: 'run' },
  { titulo: 'Hidratação', subtitulo: '18 de 30 dias batendo a meta', valor: '18 dias', tom: 'azul', icone: 'water', destaque: true },
  { titulo: 'Nutrição', subtitulo: '4 refeições no plano', valor: '2/4', tom: 'verde', icone: 'food' },
];

const hidratacaoHoje = {
  atual: '1,4 L',
  meta: '2,3 L',
  progresso: 61,
  botoes: ['+250 ml', '+500 ml', 'Meta batida'],
};

const modulos = [
  { titulo: 'Plano alimentar', desc: 'Próxima refeição às 08:00', tom: 'verde', path: '/aluna/id-prototipo/nutricao', icon: 'food' },
  { titulo: 'Treino', desc: 'Aguardando liberação', tom: 'terra', path: '/aluna/id-prototipo/treino', icon: 'run' },
  { titulo: 'Saúde', desc: 'Questionários e histórico', tom: 'azul', path: '/aluna/id-prototipo/perfil', icon: 'clipboard' },
  { titulo: 'Agenda', desc: 'Marcar avaliação', tom: 'coral', path: '/aluna/id-prototipo/agenda', icon: 'calendar' },
];

const cardapioCompleto = [
  {
    titulo: 'Café da manhã',
    hora: '08:00',
    status: 'Próxima',
    itens: [
      { nome: 'Café com adoçante', qtd: '1 copo americano duplo' },
      { nome: 'Peito de peru baixo sódio', qtd: '100 g' },
      { nome: 'Pão integral ou tapioca', qtd: '1 porção' },
    ],
  },
  {
    titulo: 'Almoço',
    hora: '12:30',
    itens: [
      { nome: 'Arroz ou batata inglesa', qtd: '100 g' },
      { nome: 'Frango, peixe ou patinho', qtd: '120 g' },
      { nome: 'Salada e legumes', qtd: 'à vontade' },
    ],
  },
  {
    titulo: 'Lanche',
    hora: '16:30',
    itens: [
      { nome: 'Iogurte natural', qtd: '1 unidade' },
      { nome: 'Fruta', qtd: '1 porção' },
      { nome: 'Castanhas', qtd: '10 g' },
    ],
  },
  {
    titulo: 'Jantar',
    hora: '20:00',
    itens: [
      { nome: 'Omelete ou proteína magra', qtd: '120 g' },
      { nome: 'Legumes refogados', qtd: '1 prato' },
      { nome: 'Azeite', qtd: '1 colher de chá' },
    ],
  },
];

const recadoEquipe = {
  ativo: true,
  destinatario: 'todos',
  tipo: 'texto',
  texto: 'Seu plano foi pensado para caber na rotina real. Hoje, foque no próximo passo simples.',
};

const copy = {
  pt: {
    date: 'Terça-feira, 14 de julho',
    greeting: 'Bom dia',
    today: 'Hoje',
    feelingTitle: 'Como você está se sentindo?',
    feelingText: 'Registre seu ritmo em poucos segundos para acompanhar energia, foco e recuperação.',
    teamNote: 'Recado da equipe',
    goals: 'Metas do mês',
    month: 'Julho',
    followUp: 'Acompanhamento',
    team: 'Team Carol',
    listen: 'Ouvir recado',
    watch: 'Assistir recado',
  },
  en: {
    date: 'Tuesday, July 14',
    greeting: 'Good morning',
    today: 'Today',
    feelingTitle: 'How are you feeling?',
    feelingText: 'Log your rhythm in a few seconds to track energy, focus and recovery.',
    teamNote: 'Team note',
    goals: 'Monthly goals',
    month: 'July',
    followUp: 'Care plan',
    team: 'Team Carol',
    listen: 'Listen',
    watch: 'Watch',
  },
};

const telas = [
  { key: 'hoje', label: 'Hoje', path: '/aluna/id-prototipo', icon: 'home' },
  { key: 'treino', label: 'Treino', path: '/aluna/id-prototipo/treino', icon: 'run' },
  { key: 'nutricao', label: 'Nutrição', path: '/aluna/id-prototipo/nutricao', icon: 'food', main: true },
  { key: 'chat', label: 'Chat', path: '/aluna/id-prototipo/chat', icon: 'chat' },
  { key: 'agenda', label: 'Agenda', path: '/aluna/id-prototipo/agenda', icon: 'calendar' },
];

function opcoesSentimento(genero) {
  const masculino = genero === 'aluno';
  return ['Bem', masculino ? 'Cansado' : 'Cansada', masculino ? 'Ansioso' : 'Ansiosa'];
}

function Icon({ name }) {
  const common = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.9, strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (name === 'run') return <svg {...common}><path d="M13 5.5a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z" /><path d="m7 21 3.4-7.5 3.3 2.7 2.3 4.8" /><path d="m5 10.6 4-1.8 3.2 2.6 4.8.4" /><path d="m10.4 13.5 1.7-4.8" /></svg>;
  if (name === 'water') return <svg {...common}><path d="M12 3.5S6.5 10 6.5 14.2a5.5 5.5 0 0 0 11 0C17.5 10 12 3.5 12 3.5Z" /></svg>;
  if (name === 'food') return <svg {...common}><path d="M7 3v8" /><path d="M5 3v8" /><path d="M9 3v8" /><path d="M5 11h4l-.5 10h-3L5 11Z" /><path d="M16 3v18" /><path d="M16 3c2 1.2 3 3 3 5.2 0 2-1 3.6-3 4.8" /></svg>;
  if (name === 'clipboard') return <svg {...common}><path d="M9 4h6v3H9z" /><path d="M15 4h3a1 1 0 0 1 1 1v16H5V5a1 1 0 0 1 1-1h3" /><path d="M8 13h8" /><path d="M8 17h5" /></svg>;
  if (name === 'calendar') return <svg {...common}><rect x="4" y="5" width="16" height="15" rx="3" /><path d="M8 3v4" /><path d="M16 3v4" /><path d="M4 10h16" /></svg>;
  if (name === 'bell') return <svg {...common}><path d="M18 8a6 6 0 1 0-12 0c0 7-2.5 7-2.5 9h17S18 15 18 8Z" /><path d="M10 21h4" /></svg>;
  if (name === 'chat') return <svg {...common}><path d="M21 11.5a8.4 8.4 0 0 1-1.1 4.2 8.7 8.7 0 0 1-7.6 4.3 8.4 8.4 0 0 1-4.2-1.1L3 20l1.1-5.1A8.4 8.4 0 0 1 3 10.7 8.7 8.7 0 0 1 7.3 3.1 8.4 8.4 0 0 1 11.5 2h.5a8.6 8.6 0 0 1 9 9v.5Z" /><path d="M8 10h8" /><path d="M8 14h5" /></svg>;
  if (name === 'home') return <svg {...common}><path d="m4 11 8-7 8 7" /><path d="M6 10v10h12V10" /></svg>;
  if (name === 'user') return <svg {...common}><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" /></svg>;
  if (name === 'check') return <svg {...common}><path d="m5 12 4 4 10-10" /></svg>;
  if (name === 'clock') return <svg {...common}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>;
  if (name === 'plus') return <svg {...common}><path d="M12 5v14" /><path d="M5 12h14" /></svg>;
  return null;
}

function TeamMessage({ tx }) {
  if (!recadoEquipe.ativo) return null;
  return (
    <section className="idp-team-message">
      <div className="idp-team-avatar">TC</div>
      <div className="idp-team-content">
        <div className="idp-team-meta">
          <span>Team Carol Macedo</span>
          <strong>{tx.teamNote}</strong>
        </div>
        <p>{recadoEquipe.texto}</p>
        {recadoEquipe.tipo === 'audio' && <button className="idp-team-primary">{tx.listen}</button>}
        {recadoEquipe.tipo === 'video' && <button className="idp-team-primary">{tx.watch}</button>}
      </div>
    </section>
  );
}

export default function IdPrototipoScreen() {
  const { user } = useAuth();
  const { lang, setLang } = useLang();
  const navigate = useNavigate();
  const { tela } = useParams();
  const telaAtual = tela || 'hoje';
  const tx = copy[lang] || copy.pt;
  const nome = user?.name?.split(' ')[0] || 'Erika';
  const sentimentos = opcoesSentimento(user?.genero);

  return (
    <main className="idp-screen">
      <section className="idp-phone">
        <div className="idp-topbar">
          <img src="/logo.svg" alt="Team Carol Macedo" />
          <div className="idp-top-actions">
            <div className="idp-lang-toggle" aria-label="Idioma do app">
              <button className={lang === 'pt' ? 'is-active' : ''} onClick={() => setLang('pt')}>PT</button>
              <button className={lang === 'en' ? 'is-active' : ''} onClick={() => setLang('en')}>EN</button>
            </div>
            <button className="idp-profile-link" onClick={() => navigate('/aluna/id-prototipo/perfil')}>Perfil</button>
          </div>
        </div>

        <header className="idp-header">
          <button className="idp-avatar" onClick={() => navigate('/aluna/id-prototipo/perfil')}>{nome.charAt(0)}</button>
          <div>
            <p>{tx.date}</p>
            <h1>{telaAtual === 'hoje' ? `${tx.greeting}, ${nome}` : telas.find(t => t.key === telaAtual)?.label || tx.greeting}</h1>
          </div>
          <button className="idp-icon-btn" aria-label="Notificações"><Icon name="bell" /></button>
        </header>

        {telaAtual === 'hoje' && (
          <>
            <section className="idp-calendar" aria-label="Semana">
              {dias.map(dia => (
                <div key={`${dia.sem}-${dia.dia}`} className={dia.ativo ? 'is-active' : ''}>
                  <span>{dia.sem}</span>
                  <strong>{dia.dia}</strong>
                  {dia.ponto && <i />}
                </div>
              ))}
            </section>

            <section className="idp-focus-card">
              <div>
                <span>{tx.today}</span>
                <h2>{tx.feelingTitle}</h2>
                <p>{tx.feelingText}</p>
              </div>
              <div className="idp-feeling-row">
                {sentimentos.map(sentimento => <button key={sentimento}>{sentimento}</button>)}
              </div>
            </section>

            <TeamMessage tx={tx} />

            <section className="idp-section">
              <div className="idp-section-head">
                <h2>{tx.goals}</h2>
                <span>{tx.month}</span>
              </div>
              <div className="idp-goals">
                {metas.map(meta => (
                  <article key={meta.titulo} className={`idp-goal idp-${meta.tom}${meta.destaque ? ' idp-goal-featured' : ''}`}>
                    <div className="idp-goal-icon"><Icon name={meta.icone} /></div>
                    <div className="idp-goal-main">
                      <div>
                        <h3>{meta.titulo}</h3>
                        <p>{meta.subtitulo}</p>
                      </div>
                      <strong>{meta.valor}</strong>
                    </div>
                    <button className="idp-mini-action" aria-label={`Atualizar ${meta.titulo}`}><Icon name="plus" /></button>
                    {meta.destaque && (
                      <div className="idp-hydration-checkin">
                        <div>
                          <span>Hoje</span>
                          <strong>{hidratacaoHoje.atual} de {hidratacaoHoje.meta}</strong>
                        </div>
                        <div className="idp-water-meter"><span style={{ width: `${hidratacaoHoje.progresso}%` }} /></div>
                        <div className="idp-hydration-actions">
                          {hidratacaoHoje.botoes.map(botao => <button key={botao}>{botao}</button>)}
                        </div>
                      </div>
                    )}
                  </article>
                ))}
              </div>
            </section>

            <section className="idp-section">
              <div className="idp-section-head">
                <h2>{tx.followUp}</h2>
                <span>{tx.team}</span>
              </div>
              <div className="idp-module-stack">
                {modulos.map((modulo, index) => (
                  <button key={modulo.titulo} className={`idp-module idp-${modulo.tom}`} style={{ '--lift': `${index * -6}px` }} onClick={() => navigate(modulo.path)}>
                    <span><Icon name={modulo.icon} /></span>
                    <div>
                      <strong>{modulo.titulo}</strong>
                      <small>{modulo.desc}</small>
                    </div>
                  </button>
                ))}
              </div>
            </section>
          </>
        )}

        {telaAtual === 'treino' && (
          <section className="idp-proto-panel">
            <div className="idp-hero-mini idp-terra">
              <span><Icon name="run" /></span>
              <div><strong>Treino da semana</strong><p>1 de 3 treinos concluído</p></div>
            </div>
            {['Treino A · Inferiores', 'Treino B · Superiores', 'Treino C · Mobilidade'].map((item, idx) => (
              <article className="idp-list-card" key={item}>
                <div className={`idp-list-icon ${idx === 0 ? 'is-done' : ''}`}><Icon name={idx === 0 ? 'check' : 'run'} /></div>
                <div><h3>{item}</h3><p>{idx === 0 ? 'Finalizado ontem' : idx === 1 ? 'Próximo treino sugerido' : 'Leve, 22 minutos'}</p></div>
                <button>{idx === 0 ? 'Ver' : 'Iniciar'}</button>
              </article>
            ))}
          </section>
        )}

        {telaAtual === 'nutricao' && (
          <section className="idp-proto-panel">
            <div className="idp-hero-mini idp-verde">
              <span><Icon name="food" /></span>
              <div><strong>Cardápio do dia</strong><p>4 refeições · meta de água 2,3 L</p></div>
            </div>

            <div className="idp-nutri-note">
              <span><Icon name="water" /></span>
              <div>
                <strong>Orientação nutricional</strong>
                <p>Ajustar para 4 refeições, priorizar proteína e aumentar a água aos poucos durante o dia.</p>
              </div>
            </div>

            <div className="idp-water-card">
              <div>
                <span>Água</span>
                <strong>{hidratacaoHoje.atual} de {hidratacaoHoje.meta}</strong>
              </div>
              <div className="idp-water-meter"><span style={{ width: `${hidratacaoHoje.progresso}%` }} /></div>
              <div className="idp-hydration-actions">
                {hidratacaoHoje.botoes.map(botao => <button key={botao}>{botao}</button>)}
              </div>
            </div>

            <div className="idp-meal-list">
              {cardapioCompleto.map((refeicao, idx) => (
                <article className={`idp-meal-card ${idx === 0 ? 'is-next' : ''}`} key={refeicao.titulo}>
                  <header>
                    <div>
                      <span>{refeicao.hora}</span>
                      <h3>{refeicao.titulo}</h3>
                    </div>
                    {refeicao.status && <strong>{refeicao.status}</strong>}
                  </header>
                  <ul>
                    {refeicao.itens.map(item => (
                      <li key={item.nome}>
                        <span>{item.nome}</span>
                        <small>{item.qtd}</small>
                      </li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </section>
        )}

        {telaAtual === 'agenda' && (
          <section className="idp-proto-panel">
            <div className="idp-calendar idp-calendar-compact" aria-label="Semana">
              {dias.map(dia => <div key={dia.dia} className={dia.ativo ? 'is-active' : ''}><span>{dia.sem}</span><strong>{dia.dia}</strong></div>)}
            </div>
            {['Avaliação de treino', 'Retorno de nutrição'].map((item, idx) => (
              <article className="idp-list-card" key={item}>
                <div className="idp-list-icon"><Icon name="calendar" /></div>
                <div><h3>{item}</h3><p>{idx === 0 ? 'Quinta · 11:00' : 'Sem horário marcado'}</p></div>
                <button>{idx === 0 ? 'Detalhes' : 'Agendar'}</button>
              </article>
            ))}
          </section>
        )}

        {telaAtual === 'chat' && (
          <section className="idp-proto-panel">
            <div className="idp-chat-hero">
              <div className="idp-team-avatar">TC</div>
              <div>
                <span>Team Carol Macedo</span>
                <strong>Canal direto com a equipe</strong>
                <p>Use para dúvidas do plano, ajustes de rotina e acompanhamento.</p>
              </div>
            </div>

            <div className="idp-chat-thread">
              <div className="idp-message is-team">
                <span>Team Carol</span>
                <p>Bom dia, {nome}. Como ficou sua hidratação ontem?</p>
              </div>
              <div className="idp-message is-user">
                <p>Consegui chegar em 2 litros, mas ainda não bati a meta.</p>
              </div>
              <div className="idp-message is-team">
                <span>Team Carol</span>
                <p>Ótimo avanço. Hoje tenta usar o botão de +500 ml duas vezes antes do almoço.</p>
              </div>
            </div>

            <div className="idp-chat-composer">
              <button aria-label="Anexar"><Icon name="plus" /></button>
              <span>Mensagem para a equipe</span>
              <button aria-label="Enviar"><Icon name="chat" /></button>
            </div>
          </section>
        )}

        {telaAtual === 'perfil' && (
          <section className="idp-proto-panel">
            <div className="idp-profile-card">
              <div className="idp-profile-avatar">{nome.charAt(0)}</div>
              <strong>{nome}</strong>
              <p>Plano mensal · idioma {lang.toUpperCase()}</p>
            </div>
            {['Evolução física', 'Questionários', 'Mensagens da equipe', 'Configurações'].map((item, idx) => (
              <article className="idp-list-card" key={item}>
                <div className="idp-list-icon"><Icon name={idx === 0 ? 'check' : idx === 1 ? 'clipboard' : idx === 2 ? 'bell' : 'user'} /></div>
                <div><h3>{item}</h3><p>{idx === 2 ? 'Recados do Team Carol Macedo' : 'Revisar informações'}</p></div>
                <button>Abrir</button>
              </article>
            ))}
          </section>
        )}

        <nav className="idp-tabbar" aria-label="Navegação protótipo">
          {telas.map(item => (
            <button key={item.key} className={telaAtual === item.key ? 'is-active' : ''} onClick={() => navigate(item.path)}>
              <Icon name={item.icon} />
              <span>{item.label}</span>
            </button>
          ))}
        </nav>
      </section>
    </main>
  );
}
